<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab v-for="item in items" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="pt-2">
      <v-tab-item> <UserLogins></UserLogins> </v-tab-item>
      <v-tab-item>
        <UserDeviceDeleted />
        <!--<UserDevice :userId="userId"/> -->
      </v-tab-item>
       <v-tab-item> <UserDownloads/> </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import UserLogins from "@/components/UserLogins";
import UserDevice from "@/components/UserDevice";
import UserDeviceDeleted from "@/components/UserDeviceDeleted";
import UserDownloads from "./../components/UserDownloads"

import * as api from "@/api";

export default {
  name: "UserActionLogs",
  components: {
    Notification,
    Pagination,
    UserLogins,
    UserDevice,
    UserDeviceDeleted,
    UserDownloads
  },
  created() {},
  methods: {},
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      tab: null,
      items: ["User Logins", "Deleted User Devices" ],
      // items: ["User Logins", "Deleted User Devices" ,"User Downloads"],
      userId: 0,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/UserActionLogs.vue